import React from 'react';
import Table from '../../components/common/Table';
import { VatRateHistoryDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface VatRateHistoryTableProps {
  data: VatRateHistoryDTO[];
  handleEdit: (row: VatRateHistoryDTO) => void;
  handleDelete: (row: VatRateHistoryDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const VatRateHistoryTable: React.FC<VatRateHistoryTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Rate (%)',
          key: 'rate',
        },

        {
          label: 'Effective Date',
          key: 'effectiveDate',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },

        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default VatRateHistoryTable;
